<template>
  <v-card min-height="518px" v-if="!isLoggedIn">
    <!-- <v-btn
      class="pa-1"
      color="indigo accent-3"
      style="font-size: 12px;line-height: 16px; font-weight: 800;"
      dark
      :to="{
        name: routerPath.publicSession.children.sessionOnDemandDetails.name,
      }"
    >
      <span>Sign Up</span>
    </v-btn> -->
    <v-card-text style="">
      <v-row class="ma-0 pa-0">
        <v-col
          class="pt-0"
          cols="12"
          align="center"
          style="font-weight: 800; font-size: 20px; line-height: 27px; color: #1D1D1D;"
        >
          {{ isLoginForm ? "Login" : getTitle(sessionDetails.status) }}
        </v-col>

        <v-col
          cols="12"
          align="center"
          style="font-size: 12px;line-height: 16px;text-align: center;color: rgba(51, 51, 51, 0.7);"
        >
          Also, get access to all our previous
          {{ sessionObject.type }} recordings and other resources.
        </v-col>
      </v-row>
      <v-form ref="signupForm" lazy-validation v-show="!isLoginForm">
        <v-row class="ma-0" v-if="!isLoggedIn">
          <v-col class="pl-0 pb-0" cols="12" md="6">
            <v-text-field
              v-model="firstName"
              placeholder="First Name"
              :rules="[rules.required, rules.notEmpty]"
              class="custom-bottom-line"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col class="pl-0 pb-0" cols="12" md="6">
            <v-text-field
              v-model="lastName"
              placeholder="Last Name"
              :rules="[rules.required, rules.notEmpty]"
              class="custom-bottom-line"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col class="pl-0 py-0" cols="12" md="12">
            <v-text-field
              placeholder="Email"
              v-model="email"
              :rules="[rules.email]"
              class="custom-bottom-line"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col class="pl-0 py-0" cols="12" md="12">
            <v-text-field
              placeholder="Contact No."
              v-model="mobile"
              :rules="[]"
              class="custom-bottom-line"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col
            class="pl-0 py-0"
            cols="12"
            md="12"
            style="align-self: flex-end;"
          >
            <v-select
              :items="occupation.occupationList"
              name="user_occupation"
              v-model="occupation.vModel"
              :rules="[rules.required]"
              item-text="name"
              return-object
              outlined
              placeholder="How do you best describe yourself"
              class="custom-bottom-line"
              dense
            ></v-select>
          </v-col>
          <v-col
            style="align-self: flex-end;"
            class="pl-0 py-0"
            cols="12"
            md="12"
          >
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              placeholder="Set your password"
              class="custom-bottom-line"
              :rules="[rules.required]"
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              outlined
              @keyup.enter="submitSignUpForm"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pl-0 mt-n6">
            <v-row class="ma-0">
              <v-checkbox
                class="ma-0"
                dense
                v-model="agreeTerms"
                hide-details
              />
              <v-col
                class="pa-0"
                style="font-weight: normal;font-size: 12px;line-height: 16px;color: #919191;"
              >
                I consent to receive more resources, offers, and events related
                to child development.
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0 pr-3">
          <v-spacer />
          <v-btn
            color="#5271FF"
            @click="validateAndRegister()"
            dark
            width="100%"
            :loading="$store.state.webinar.buttonLoading"
            style="font-size:16px"
          >
            {{ getButtonText(sessionDetails.status) }}
          </v-btn>
        </v-row>
        <v-row
          align="center"
          justify="center"
          v-if="!isLoggedIn"
          class="ma-0 mt-2"
        >
          <div
            style="font-size: 12px;line-height: 16px;text-align: center;color: rgba(51, 51, 51, 0.7);"
          >
            If you already have an account?
          </div>
          <v-btn
            text
            class="pa-1"
            color="indigo accent-3"
            style="font-size: 12px;line-height: 16px; font-weight: 800;"
            dark
            x-small
            @click="isLoginForm = true"
          >
            <span>Login</span>
          </v-btn>
        </v-row>
      </v-form>
      <v-form ref="loginForm" class="mt-8" lazy-validation v-show="isLoginForm">
        <v-row class="ma-0">
          <v-col class="pl-0 py-0" cols="12" md="12">
            <v-text-field
              placeholder="Email/Contact"
              v-model="loginForm.identifier"
              :rules="[rules.required]"
              class="custom-bottom-line"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col
            style="align-self: flex-end;"
            class="pl-0 py-0"
            cols="12"
            md="12"
          >
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              placeholder="Password"
              class="custom-bottom-line"
              :rules="[rules.required]"
              v-model="loginForm.password"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              outlined
              @keyup.enter="submitLoginForm"
              dense
            ></v-text-field>
            <v-row align="right" justify="end" class="mt-n5">
              <v-btn
                text
                color="indigo accent-3"
                small
                :to="{
                  name: routerPath.auth.children.forgotPassword.name,
                }"
              >
                <span>Forgot Password?</span>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0 pr-3">
          <v-spacer />
          <v-btn
            class="mt-5"
            color="#5271FF"
            @click="submitLoginForm()"
            dark
            width="100%"
            :loading="loginForm.submitting"
            style="font-size:16px"
          >
            Login &amp; {{ getButtonText(sessionDetails.status) }}
          </v-btn>
        </v-row>
        <v-row align="center" justify="center" class="ma-0 mt-4">
          <div
            style="font-size: 12px;line-height: 16px;text-align: center;color: rgba(51, 51, 51, 0.7);"
          >
            If you don't have an account
          </div>
          <v-btn
            text
            class="pa-1"
            color="indigo accent-3"
            style="font-size: 12px;line-height: 16px; font-weight: 800;"
            dark
            x-small
            @click="isLoginForm = false"
          >
            <span>Sign Up</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
  <div v-else style="height:518px; padding-top:50%" class="px-5">
    <v-btn
      color="#FFFFFF"
      @click="
        sessionDetails.status != 'Published' && sessionDetails.status != 'Draft'
          ? registerWebinar()
          : requestWebinar()
      "
      light
      width="100%"
      :loading="$store.state.webinar.buttonLoading"
      style="font-size:16px"
    >
      <span
        style="font-weight: 500;font-size: 16px;line-height: 22px;color: #506CFF;"
      >
        {{ getButtonText(sessionDetails.status) }}
      </span>
    </v-btn>
  </div>
</template>

<script>
  import RULES from "../../common/fieldRules";
  import Axios from "../../api/BaseAxios";
  import {
    API_COMMON_URL,
    ROUTER_URL,
    API_CLIENT_URL,
  } from "../../constants/urls";
  import AuthApiHelper from "../..//api/common/AuthApis";
  import Keys from "../../constants/keys";
  import FirebaseHelper from "../../api/common/FirebaseApis";
  import authToken from "../../common/authToken";
  import SessionSeriesApiHelper from "../../api/common/SessionSeriesApi";

  import AmplitudeHelper from "../../amplitude";
  import store from "../../store";
  import router from "../../router";

  export default {
    name: "RegisterLoginCard",
    props: ["sessionDetails", "sessionObject"],
    components: {},
    data() {
      return {
        routerPath: ROUTER_URL,
        isLoginForm: false,
        loading: false,
        rules: RULES,
        firstName: null,
        lastName: null,
        email: "",
        mobile: "",
        occupation: {
          occupationList: [],
          vModel: null,
        },
        showPassword: false,
        password: "",
        agreeTerms: false,
        identifier: null,
        loginForm: {
          identifier: "",
          password: "",
          submitted: false,
          submitting: false,
        },
      };
    },
    created() {},
    computed: {
      isLoggedIn() {
        return this.$store.state.isLoggedIn || authToken.isCorrectAccessToken();
        // return authToken.isCorrectAccessToken();
      },
    },
    watch: {
      isLoginForm() {
        this.$ref.signupForm.reset();
        this.$ref.signinForm.reset();
      },
    },
    methods: {
      getFormData() {
        var self = this;

        const successHandler = (res) => {
          self.occupation.occupationList = res.data.data;
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        Axios.request_GET(
          API_COMMON_URL.userRegister,
          {},
          {},
          successHandler,
          failureHandler,
          false,
          false
        );
      },
      getTitle(status) {
        switch (status) {
          case "On-Demand":
            return "Create Account and Register"; //"Watch Webinar Recording"

          case "Published":
            return "Create Account and Register"; //"Request Webinar"

          case "Draft":
            return "Create Account and Register"; //"Request Webinar"

          case "Scheduled":
            return "Create Account and Register"; //"Register Now"
        }
      },
      getButtonText(status) {
        switch (status) {
          case "On-Demand":
            return "Watch Now";

          case "Published":
            return "Request the webinar"; // "Request Webinar"

          case "Draft":
            return "Request the webinar"; // "Request Webinar"

          case "Scheduled":
            return this.isLoginForm ? "Register" : "Register Now";
        }
      },
      /**
       * Form submit handler
       * @param e
       */
      submitLoginForm() {
        if (this.$refs.loginForm.validate()) {
          const self = this;
          this.loginForm.submitting = true;

          console.log("Form validated");
          /**
           * Success handler of API call
           */
          const successHandler = (res) => {
            AmplitudeHelper.registerEvent("Webinar User Login", formData);
            console.log("success ", res);

            store.dispatch("dashboard/updateDashboardTab", "Steps");

            // Save token in local storage
            localStorage.setItem("token", res.headers.token);
            document.cookie = `accesstoken=${res.headers.token}; domain=.eblity.com`;
            this.$store.state.isLoggedIn = true;
            try {
              localStorage.setItem("client_name", res.data.client_details.name);
            } catch (e) {
              console.log(e);
            }
            self.loginForm.submitting = false;
            console.log(authToken.decodedToken());

            AmplitudeHelper.registerAmplitudeEvent("login success");
            // this.registerWebinar();
            this.getSessionSeriesDetails();
          };
          /**
           * Failure handler of API call
           */
          const failureHandler = (res) => {
            console.log("Failure ", res);
            self.loginForm.submitting = false;
          };
          let formData = {};
          formData[Keys.identifier] = this.loginForm.identifier.trim();
          formData[Keys.password] = this.loginForm.password;

          /**
           * API Call for login
           */
          Axios.request_POST(
            API_COMMON_URL.eblityLogin,
            formData,
            {},
            successHandler,
            failureHandler,
            false,
            false
          );
        }
      },

      validateAndRegister() {
        if (this.$refs.signupForm.validate()) {
          this.$store.state.webinar.buttonLoading = true;
          let formData = {};
          formData[Keys.FIRST_NAME] = this.firstName.trim();
          formData[Keys.LAST_NAME] = this.lastName.trim();
          formData[Keys.EMAIL] = this.email.trim();
          formData[Keys.MOBILE] = this.mobile.trim();
          formData[Keys.password] = this.password.trim();
          formData[Keys.OCCUPATION_ID] = this.occupation.vModel.id;
          formData[Keys.PROMOTIONAL_NOTIFICATION] = this.agreeTerms;

          const registerSuccessHandler = (res) => {
            AmplitudeHelper.registerEvent("Webinar User Register", formData);
            console.log("validateAndRegister success", res);
            localStorage.setItem("token", res.data.token);

            authToken.deleteCookie(`accesstoken`);

            document.cookie = `accesstoken=${res.data.token}; domain=.eblity.com`;

            this.$store.state.isLoggedIn = true;

            AmplitudeHelper.registerAmplitudeEvent("new user sign up", {
              location: this.sessionObject.type.toLowerCase(),
              "user type": this.occupation.vModel.name,
            });

            let data = {};
            data[Keys.FCM_TOKEN] = authToken.getFCMToken();
            FirebaseHelper.setUserFCMToken(data, null, null);

            this.$store.state.payment.sessionSeriesId = this.sessionDetails.id;
            let sessions = [];
            this.sessionDetails.sessions.forEach((element) => {
              sessions.push(element.id);
            });
            this.$store.state.payment.sessions = sessions;
            this.$store.state.payment.discription = this.sessionDetails.title;
            this.$store.state.payment.amount = this.sessionDetails.price;
            if (
              this.sessionDetails.status != "Published" &&
              this.sessionDetails.status != "Draft"
            )
              this.registerWebinar();
            else {
              this.requestWebinar();
            }
          };

          const registerFailureHandler = (res) => {
            console.log(res);
            this.$store.state.webinar.buttonLoading = false;
            if (res.data.is_user_exist) {
              this.loginForm.identifier = this.email
                ? this.email.trim()
                : this.mobile.trim();
              this.isLoginForm = true;
            }
          };

          AuthApiHelper.registerUser(
            this.firstName.trim(),
            this.lastName.trim(),
            this.email.trim(),
            this.mobile.trim(),
            this.password.trim(),
            registerSuccessHandler,
            registerFailureHandler,
            this.occupation.vModel.id,
            this.agreeTerms
          );
        }
      },

      registerWebinar() {
        this.$store.state.webinar.buttonLoading = true;

        SessionSeriesApiHelper.enrollForSessionSeries(
          this.sessionObject,
          this.$store.state.isMembershipEnabled
        );
      },

      requestWebinar() {
        this.$store.state.webinar.buttonLoading = true;
        if (this.sessionDetails.is_requested) {
          store.dispatch("snackBar/showToast", {
            message: "You have already requested this webinar",
            color: "S",
          });
          this.$store.state.webinar.buttonLoading = false;
        } else {
          const self = this;
          let requestParams = {};
          requestParams[Keys.SESSION_SERIES_ID] = this.sessionDetails.id;
          const successHandler = (res) => {
            AmplitudeHelper.registerEvent(
              "Request webinar",
              this.sessionObject
            );

            console.log({ res });
            self.sessionDetails.is_requested = true;

            store.dispatch("snackBar/showToast", {
              message: "Thank you for requesting this webinar",
              color: "S",
            });

            store.state.sessionSeriesDetails.requested =
              store.state.sessionSeriesDetails.data;
            store.state.sessionSeriesDetails.purchased = null;

            //  router.push({
            //     name: ROUTER_URL.publicSession.children.sessionThankYou.name,
            //   });

            if (store.state.sessionSeriesDetails.data.type == "Webinar") {
              router.push({
                name: ROUTER_URL.publicSession.children.webinarThankYou.name,
              });
            } else if (
              store.state.sessionSeriesDetails.data.type == "Workshop"
            ) {
              router.push({
                name: ROUTER_URL.publicSession.children.workshopThankYou.name,
              });
            }

            this.$store.state.webinar.buttonLoading = false;
          };
          const failureHandler = (res) => {
            console.log(res);
            this.$store.state.webinar.buttonLoading = false;
          };

          Axios.request_POST(
            API_CLIENT_URL.requestSession,
            requestParams,
            {},
            successHandler,
            failureHandler,
            false,
            true
          );
        }
      },

      getSessionSeriesDetails() {
        const successHandler = (res) => {
          console.log(res);
          SessionSeriesApiHelper.enrollForSessionSeries(res.data.data);
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        var requestParams = {};
        requestParams[Keys.ID] = this.sessionObject.id;
        requestParams[Keys.TYPE] = "Session";

        SessionSeriesApiHelper.getSessionSeriesDetails(
          requestParams,
          successHandler,
          failureHandler
        );
      },
    },
    mounted() {
      this.$store.state.webinar.buttonLoading = false;
      this.getFormData();
    },
  };
</script>

<style scoped></style>
